export default "__VITE_ASSET__BrY7KUA2__"